import { Link, useParams } from 'react-router';
import { XMarkIcon } from '@heroicons/react/24/outline';
import NodeFormWrapper from './NodeFormWrapper';
import { useIsPathwayLocked } from '@/stores/pathwayStore';

const NodeModal = () => {
  const { projectId, pathwayId, caseId, nodeId } = useParams();
  const locked = useIsPathwayLocked();

  const actions = (
    <Link to={`/projects/${projectId}/build/pathways/${pathwayId}/${caseId}`}>
      <XMarkIcon className="h-5 w-5" />
    </Link>
  );

  return (
    <div className="group node h-full relative">
      <NodeFormWrapper nodeId={nodeId} actions={actions} locked={locked} />
    </div>
  );
};

export default NodeModal;
